export const Variables = {
  registerLink: "https://empresa.caju.com.br/classic/#/cadastro",
  stagingRegisterLink: "https://empresa-staging.caju.com.br/classic/#/cadastro",

  presentationLink: 'https://exemplos.caju.com.br/caju_apresentacao_comercial.pdf',
  patGuideLink: 'https://blog.caju.com.br/wp-content/uploads/2025/12/Guia-Definitivo-O-que-muda-no-PAT-Decreto-12712.pdf',
};
